// SPDX-FileCopyrightText: 2025 Land Baden-Württemberg <InnoLab@stm.bwl.de>
//
// SPDX-License-Identifier: MPL-2.0

// IMPORTANT REMARK:
// For historical reasons, this file contains references to websockets in the
// filename and the fields below. However, the websocket functionality has since
// been removed.
// The remaining functionality is used to display various messages to the end
// user in a Toast via `Logging.svelte`.
// The uuid is used to identify the session for the feedback functionality.

import { writable } from 'svelte/store';
import { v4 as uuidv4 } from 'uuid';

// Generate random UUID as Session ID; try to use in-browser crypto module (available in SSL connections
// and on localhost) and fall back to "normal" UUID generation if crypto module is not available
// (e.g. plain http-connections)
let uuid;
if (window.crypto && typeof window.crypto.randomUUID === 'function') {
  uuid = window.crypto.randomUUID();
} else {
  uuid = uuidv4();
}

const currentErrorMessage = writable('');
const currentWarningMessage = writable('');
const currentInfoMessage = writable('');
const currentDebugMessage = writable('');
const currentLimitMessage = writable('');

const resetStore = writable(0);

const resetMessages = () => {
  //somehow trigger resetStore to get update event in components
  resetStore.update((n) => n + 1);
};

export default {
  currentMessage: {
    error: currentErrorMessage,
    warning: currentWarningMessage,
    info: currentInfoMessage,
    debug: currentDebugMessage,
    limit: currentLimitMessage,
    reset: resetStore,
  },
  websocket: {
    resetMessages: resetMessages,
  },
  uuid: uuid,
};
